import React from "react";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { makeStyles } from "@material-ui/core/styles";
import styled from "styled-components";

export const Row = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
`;
export const Error = styled.span`
  display: block;
  font-size: 12px;
  line-height: 12px;
  color: #c9243f;
  margin: -18px 0 4px auto;
  width: 100%;
  text-align: left;
`;
const useStyles = makeStyles({
  root: {
    fontSize: "9px",
    marginBottom: "25px",
  },
  label: {
    fontSize: "9px",
  },
  checkbox: {
    padding: "3px 9px",
    fontSize: "14px",
  },
});

const cl = {
  root: {
    fontSize: "9px",
    marginBottom: "25px",
  },
  label: {
    fontSize: "9px",
  },
  checkbox: {
    padding: "3px 9px",
    fontSize: "14px",
  },
};

const CheckboxElement = ({
  label,
  value,
  registerRef,
  checked,
  handleChange,
  error,
}) => {
  const classes = useStyles();
  return (
    <Row>
      <FormControlLabel
        className={(classes.label, classes.root)}
        style={{ ...cl.label, ...cl.root }}
        control={
          <Checkbox
            onChange={handleChange}
            name={value}
            inputRef={registerRef}
            className={classes.checkbox}
            checked={checked}
          />
        }
        label={label}
      />
      {error && <Error>{error.message || "To pole jest wymagane"}</Error>}
    </Row>
  );
};

export default CheckboxElement;
